<template>
  <div>
    <div class="header-time-box" v-if="type !== 'alApply' && type !== 'xal'">
      评审时间：{{ reviewStartTime }} — {{ reviewEndTime }}
    </div>
    <!-- 专家端：网络育人创新联盟筛选 -->
    <div v-if="alApplyExpertFilter" class="list-filter-panel">
      <div class="list-filter-row filter-dimension-grid">
        <div class="filter-dimension-block filter-dimension-block--primary">
          <div class="filter-dimension-title">大赛分组</div>
          <div class="filter-chip-list filter-chip-list--lg">
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: !queryCriteria.levelType }"
              @click="setExpertLevelFilter()"
            >全部</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: queryCriteria.levelType === '1' }"
              @click="setExpertLevelFilter('1')"
            >中职组</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: queryCriteria.levelType === '2' }"
              @click="setExpertLevelFilter('2')"
            >高职组</span>
          </div>
        </div>
        <!-- <div class="filter-dimension-block filter-dimension-block--primary">
          <div class="filter-dimension-title">团队类型</div>
          <div class="filter-chip-list filter-chip-list--lg">
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: !queryCriteria.teamType }"
              @click="setExpertTeamFilter()"
            >全部</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: queryCriteria.teamType === 'teacher' }"
              @click="setExpertTeamFilter('teacher')"
            >教师团队</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: queryCriteria.teamType === 'student' }"
              @click="setExpertTeamFilter('student')"
            >学生团队</span>
          </div>
        </div> -->
      </div>
    </div>
    <div class="header-search-box flex align-items-center border-box">
      <div class="flex align-items-center">
        <!-- <div v-if="type === 'szStudio'">名称：</div> -->
        <div v-if="type === 'educationalBrand'">工作室名称：</div>
        <!-- <div v-if="type === 'szMicroClass'">思政微课名称：</div> -->
        <input class="input-style" type="text" v-if="type != 'szStudio' && type!='alApply' && type!='xal'"
          v-model="queryCriteria.name" />
      </div>
      <div class="flex align-items-center">
        <div v-if="type === 'szStudio'">课程名称 : </div>
        <div v-if="type === 'educationalBrand'">主持人 :</div>
        <input class="input-style" type="text" v-if="type === 'educationalBrand' || type === 'szStudio'" v-model="queryCriteria.name" />
      </div>
      <!-- <div class="flex align-items-center" v-if="type === 'alApply' || type === 'xal'">
        <div>省：</div>
        <a-select default-value="全部" v-model="queryCriteria.provincecode" style="width: 120px" >
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option
            v-for="(item, index) in provinceList"
            :key="index"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div> -->
      <!-- <div class="flex align-items-center" style="margin-left:20px;" v-if="type === 'alApply' || type === 'xal'">
        <div>学校名称：</div>
         <a-select
         style="width: 200px;"
      	allowClear
		    show-search
		    v-model="queryCriteria.schoolName"
		    placeholder="请输入学校名称"
		    :default-active-first-option="false"
		    :show-arrow="false"
		    :filter-option="false"
		    :not-found-content="null"
		    @search="handleSearch"
		    >
		    <a-select-option v-for="d in schoollist" :key="d.name">
		      {{ d.name }}
		    </a-select-option>
  			</a-select> -->
        <!--<input class="input-style" type="text" v-model="queryCriteria.schoolName" />-->
      <!-- </div> -->
      <div class="flex flex-4 align-items-center" style="margin-left:20px;">
        <div v-if="type === 'alApply' || type === 'xal'">作品名称：</div>
        <div v-else>作品名称：</div>
        <input class="input-style" type="text" v-model="queryCriteria.zpname" />
      </div>
      <div class="flex align-items-center" style="margin-right:20px;">
        <div>资料完整：</div>
        <a-select default-value="全部" style="width: 120px;"  @change="handleChange">
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option value="0"> 完整 </a-select-option>
          <a-select-option value="1"> 未完整 </a-select-option>
        </a-select>
      </div>
      <div class="flex align-items-center" v-if="type !== 'alApply' && type !== 'xal'">
        <div>学校类型：</div>
        <a-radio-group v-model="queryCriteria.levelType">
          <a-radio value="">全部</a-radio>
          <a-radio value="2">高职组</a-radio>
          <a-radio value="1">中职组</a-radio>
        </a-radio-group>
      </div>
      <div class="search-btn flex flex-center align-items-center" @click="goQuery">
        <img class="img-box" src="@/assets/images/img48.png" alt="" />
        <div>查询</div>
      </div>
      </div>
    <div class="text1"  v-if="type != 'alApply' && type != 'xal'">
      	当前共有<span class="color-red"> {{ schoolCount }} </span>所学校，<span class="color-red">
        {{ applyCount }} </span>个作品
    </div>
     <div class="text1" v-if="type == 'alApply' || type == 'xal'">
                      当前共有<span class="color-red">{{ provinceCount }}</span>个省,<span class="color-red">{{ schoolCount }}</span>所学校
        <!--<span class="color-red">{{ applyCount }}</span> 
        <!--<template v-if="wokrName">个{{ wokrName }}</template>
        <template v-else>门课程</template>-->
      </div>
    <div class="expert-table-box">
    	<!--:scroll="{ x: 1280 }"-->
      <a-table style="text-align: center" :locale="{ emptyText: '暂无数据' }" :pagination="pagination"
        :columns="columns" :data-source="data" :bordered="true" rowKey="id"
        @change="handleTableChange" >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <span class="flex flex-around" slot="action" slot-scope="record">
          <div class="flex align-items-center" style="cursor: pointer" @click="review(record)">
            <img class="ywcimg"
                 v-if="(record.score && record.scoreFile) && (record.score != '-' || record.scoreFile != '-') "
                 src="../../assets/images/ywc.png" alt="" />
            <img class="img-box" src="../../assets/images/img56.png" alt="" />
            {{ getPreviewTimeout(record)}}
            <!-- ? "审核" : "查看" -->
          </div>
        </span>
         <!-- <template slot="teamType" slot-scope="text">
          <div style="padding: 10px" v-if="text=='teacher'">教师团队</div>
          <div style="padding: 10px" v-if="text=='student'">学生团队</div>
          <div style="padding: 10px" v-else-if="!text || text === '-'">-</div>
        </template> -->
        <template slot="applyFilesFull" slot-scope="text">
          <img v-if="text == 0" class="img-box-hint" src="../../assets/images/img57.png" alt=""
            title="资料完整" />
          <img v-else class="img-box-hint c-p" src="../../assets/images/img58.png" alt=""
            title="资料不完整" />
        </template>
       
        <template slot="duration" slot-scope="text">
          <img v-if="
              (text / 1000 / 60).toFixed(0) >= 8 && (text / 1000 / 60).toFixed(0) <= 15
            " class="img-box-hint" src="../../assets/images/img57.png" alt=""
            :title="getTime(text) + '\n时长合格'" />
          <img v-else class="img-box-hint" src="../../assets/images/img58.png" alt="" :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在8-15分钟内`
            " />
        </template>
        <template slot="duration1" slot-scope="text">
          <img v-if="
              (text / 1000 / 60).toFixed(0) >= 8 && (text / 1000 / 60).toFixed(0) <= 15
            " class="img-box-hint" src="../../assets/images/img57.png" alt=""
            :title="getTime(text) + '\n时长合格'" />
          <img v-else class="img-box-hint" src="../../assets/images/img58.png" alt="" :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在8-15分钟内`
            " />
        </template>
        <template slot="duration2" slot-scope="text">
          <img v-if="
              (text / 1000 / 60).toFixed(0) >= 8 && (text / 1000 / 60).toFixed(0) <= 15
            " class="img-box-hint" src="../../assets/images/img57.png" alt=""
            :title="getTime(text) + '\n时长合格'" />
          <img v-else class="img-box-hint" src="../../assets/images/img58.png" alt="" :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在8-15分钟内`
            " />
        </template>
        <template slot="duration3" slot-scope="text">
          <img v-if="
              (text / 1000 / 60).toFixed(0) >= 8 && (text / 1000 / 60).toFixed(0) <= 15
            " class="img-box-hint" src="../../assets/images/img57.png" alt=""
            :title="getTime(text) + '\n时长合格'" />
          <img v-else class="img-box-hint" src="../../assets/images/img58.png" alt="" :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在8-15分钟内`
            " />
        </template>
        <template slot="applyScoreFile" slot-scope="text">
          <span v-if="text == '-'">-</span>
          <img v-else class="img-box-hint" src="../../assets/images/img51.png" :title="text"
            style="cursor: pointer" @click="preview(text)" />
        </template>
         <template slot="izReview" slot-scope="text,record">

          <span v-if="text=='1' &&(izScoring || izReview)" style="color:#9A0B00;font-weight:600;cursor: pointer;" @click="reviewShow(record)">已评审</span>
          <span v-else-if="text=='1' &&(!izScoring && !izReview)" style="color:#9A0B00;font-weight:600;cursor: pointer;" >已评审</span>
          <span v-else>未评审</span>
        </template>
      </a-table>
    </div>
    <div class="preview-pop-box" v-if="showPreviewPop">
      <div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
        <preview type="expert" @openReson="openReson" @closePreview="closePreview" @goNewPage="goNewPage"
          @submitPreview="submitPreview" :previewTimeout="previewTimeout"
          :preViewData="preViewData"  :evaluationTablePreview="evaluationTablePreview"></preview>
      </div>
    </div>
    <div class="preview-pop-box" v-if="isshow">
      <div class="preview-box">
       <!--<expertlist
          :preViewData="preViewData"
          :expertUserId="expertUserId"
          @closePreview="isshow = false"
        ></expertlist>-->
        <expertdata :preViewData="preViewData"
          :expertUserId="expertUserId"
          @closePreview="isshow = false">
        </expertdata>
      </div>
    </div>
    <div class="preview-pop-box" v-if="show">
      <!-- v-draggable -->
    <div class="contentbox"  >
    	   <div class="boxheader" >
    	   	评审意见
    	   	<span class="close" @click="colseDialog">X</span>
    	   </div>
				 <textarea name=""  v-model="reson" placeholder="请输入评审意见" class="boxtextarea" ></textarea>
				 <button  @click="gosubmit"  class="boxbutton">提交</button> 
    </div>
    </div>
    <preview-img v-if="visibles" ref="views" ></preview-img>
  </div>
</template>

<script>
import  draggable from "../../utils/draggable"
import { lxExpertApplyReview,getAction,mhSchool,postAction} from '@/api/index';
import { formatDuring } from '../../utils/time';
import preview from './preview';
import expertlist from "./expertList";
import expertdata from "./expertData";
import previewImg from '../previewImg.vue';
const columns = [
  {
    title: '序号',
    dataIndex: 'sequenceNumber',
    id: 'sequenceNumber',
    align: 'center',
    scopedSlots: { customRender: 'sequenceNumber' },
    width: 70,
    fixed: 'left',
  },
  // {
  //   title: "名称",
  //   dataIndex: "principals",
  //   key: "principals",
  //   align: "center",
  //   width: 220,
  // },

  {
    title: '课程名称',
    dataIndex: 'name',
    key: 'name',
    align: 'center',
    width: 120,
  },
  {
    title: '比赛分组',
    dataIndex: 'levelType_dictText',
    key: 'levelType_dictText',
    align: 'center',
    width: 150,
  },
  {
    title: '作品名称',
    dataIndex: 'zpname',
    id: 'zpname',
    align: 'center',
    width: 150,
  },
  {
    title: '负责人',
    dataIndex: 'principals',
    id: 'principals',
    align: 'center',
    width: 150,
  },
  {
    title: '联系电话',
    dataIndex: 'phone',
    key: 'phone',
    align: 'center',
    width: 120,
  },
  {
    title: '比赛视频1',
    dataIndex: 'duration',
    id: 'duration',
    align: 'center',
    scopedSlots: { customRender: 'duration' },
    width: 100,
  },
  {
    title: '比赛视频2',
    dataIndex: 'duration1',
    id: 'duration1',
    align: 'center',
    scopedSlots: { customRender: 'duration1' },
    width: 100,
  },
  {
    title: '比赛视频3',
    dataIndex: 'duration2',
    id: 'duration2',
    align: 'center',
    scopedSlots: { customRender: 'duration2' },
    width: 100,
  },
  {
    title: '比赛视频4',
    dataIndex: 'duration3',
    id: 'duration3',
    align: 'center',
    scopedSlots: { customRender: 'duration2' },
    width: 100,
  },
  {
    title: '资料完整',
    dataIndex: 'applyFilesFull',
    id: 'applyFilesFull',
    align: 'center',
    scopedSlots: { customRender: 'applyFilesFull' },
    width: 100,
  },
  {
    title: '分数',
    dataIndex: 'score',
    key: 'score',
    align: 'center',
    width: 80,
  },
  {
    title: '评审表',
    dataIndex: 'scoreFile',
    key: 'scoreFile',
    align: 'center',
    scopedSlots: { customRender: 'applyScoreFile' },
    width: 80,
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    width: 150,
    scopedSlots: { customRender: 'action' },
    fixed: 'right',
  },
];
export default {
  name: '',
  components: {
    preview,
    previewImg,
    expertlist,
    expertdata
  },
  directives:{
  	 draggable,
  },
  props: {
    columns: {
      type: Array,
      default: () => columns,
    },
    title: String,
    reviewStartTimestamp: {
      type: String,
      default: '',
    },
    reviewEndTimestamp: {
      type: String,
      default: '',
    },
    reviewStartTime: {
      type: String,
      default: '',
    },
    reviewEndTime: {
      type: String,
      default: '',
    },
    timestampStartTime: {
      type: String,
      default: '',
    },
    timestampEndTime: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
    },
    type: String,
    wokrName: {
      type: String,
      default: '',
    },
    applyCount: {
      type: Number,
    },
    schoolCount: {
      type: Number,
    },
    provinceCount:{
      type: Number,
      default: 0,
    },
    pagination: {
      type: Object,
    },
  },
  data() {
    return {
//  	max:300,
    	schoollist:[],
      showPreviewPop: false,
      url: '',
      visibles: false,
      queryCriteria: {
        name: '',
        schoolName: '',
        principals: '',
        Integrity: '',
        zpname:"",
        provincecode:'',
        levelType:'',
        teamType:'',
      },
      fullscreen: false,
      previewTimeout: false,
      preViewData: [],
      provinceList:[],
      timeout:'',
      schoollist:[],
      show:false,
      reson:'',
      isshow:false,
      expertUserId:'',
      evaluationTablePreview:false,
      izScoring:false,
      izReview:false,
    };
  },
  computed: {
    alApplyExpertFilter() {
      return this.type === "alApply" || this.type === "xal";
    },
  },
  watch: {},
  created() {
//	  this.expertUserId=this.$store.state.user.id;
  	if(this.type=='alApply' || this.type=='xal'){
  			this.getProvince();
        this.getStatus();
  	}
  },
  mounted() {
  	this.expertUserId=this.$store.state.user.id;
  },
  methods: {
    gosuggestion(){
        getAction('/lx/lxApplyExpertEvaluation/getEvalution?applyType=4',{}).then((res) => {
					if (res.code === 200) {
             if(res.result && res.result.evaluation){
               this.reson=String(res.result.evaluation).replaceAll("\\n", "\n");
             }else{
               this.reson='';
             }
				    
             this.show=true;
					}else{
					  this.$message.error(res.message);
					}
				});
    },
    getStatus(){
				getAction('/lx/lxApply/getReviewAndScore',{}).then((res) => {
					if (res.code === 200) {
					this.izScoring=res.result.izScoring==1?true:false;
					this.izReview=res.result.izReview==1?true:false;
					}else{
					this.$message.error(res.message);
					}
				});
		 },
  	closePreview(){
  		 this.showPreviewPop = false;
  		 this.show = false;
  		 this.$emit('updataInfo');
  	},
  	reviewShow(row){
		 this.isshow=true;
		 this.preViewData = row;
  		
  	},
  	gosubmit(){
  		let params={
  			// applyIds:[],
        applyType:4,
  		};
  		if(this.reson==''){
  			 this.$message.warning('请发表评审意见');
  			 return false;
  		}
  		let reson=String(this.reson).replaceAll("\n","\\n");
  		// params.applyIds.push(this.preViewData.id);
  		params.evaluation=reson;
      this.submitdata(params);
  		// this.submitPreview(params);
  	},
    submitdata(params){
       postAction('/lx/lxApplyExpertEvaluation/saveEvalution',params).then((res) => {
					if (res.code === 200) {
					this.$message.success('提交成功');
          this.reson='';
					this.colseDialog();
					}else{
					this.$message.error(res.message);
					}
				});
    },
  	colseDialog(){
  		this.show=false;
  	},
  	openReson(value){
  		 this.reson='';
  		 this.show=value;
  	},
  	handleSearch(value) { 
  		if(value!=''){
  			this.searchSchool(value);
  		}
    },
    searchSchool(value){
  		let that=this;
  		if(that.timeout){
  			 clearTimeout(that.timeout);
  			 this.schoollist=[];
  		}
		 that.timeout = setTimeout(()=>{
		 	 	let params={
  		  	name:value,
  		  	provincecode:that.queryCriteria.provincecode,
  		  };
				mhSchool(params).then((res) => {
	        if (res.code == 200) {
	        	if(res.result.length>0){
	        		 that.schoollist = res.result;
	        	}else{
	        		 that.queryCriteria.schoolName=value;
	        	}
	         
	        }
       });
		 }, 500);
     
  	},
  	getProvince() {
      getAction("/pcity/queryByPid", { pid: 0 }).then((res) => {
        if (res.code == 200) {
          this.provinceList = res.result;
        }
      });
    },
    getTime(time) {
      return formatDuring(time);
    },
    handleChange(value) {
      this.queryCriteria.Integrity = value;
    },
    getPreviewTimeout() {
      // record
      // if (record.score === null || record.score === '-') {
      //   return "评审";
      // } else {
      //   return "查看";
      // }
      var date1 = new Date();
      var timestamp = Date.parse(date1);
      if (
        timestamp > this.reviewStartTimestamp &&
        timestamp < this.reviewEndTimestamp
      ) {
        this.previewTimeout = true;
        return '评审';
      } else {
        this.previewTimeout = false;
        return '查看';
      }
    },
    review(row) {
      this.preViewData = row;
      var date1 = new Date();
      var timestamp = Date.parse(date1);
      if (timestamp < this.reviewStartTimestamp) {
        if (row.score === null) {
          this.$message.warning('评审时间还没开始');
        } else {
//      	this.$store.commit('updateItems',row);
//      	localStorage.setItem('items', JSON.stringify(row));
          this.showPreviewPop = true;
//				this.$router.push({path:'/personalCenter/rateScore',query:{userid:this.$store.state.user.id}});
        }
      } else if (timestamp > this.reviewEndTimestamp) {
//      this.showPreviewPop = true;
        this.$message.warning('评审时间已经结束');
      } else if (
        timestamp > this.reviewStartTimestamp &&
        timestamp < this.reviewEndTimestamp
      ) {
      	this.$store.commit('updateItems',row);
      	localStorage.setItem('items', JSON.stringify(row));
      	this.$router.push({path:'/personalCenter/rateScore',query:{userid:this.$store.state.user.id}});
//      this.showPreviewPop = true;
        this.previewTimeout = true;
//      if (row.score === null) {
//        this.$message.success('开始评审');
//      }
      }
    },
    preview(item) {
      this.visibles = true
      this.$nextTick(()=>{
        this.$refs.views.init(item)
      })
    },
    setExpertLevelFilter(value) {
      this.queryCriteria.levelType =
        value === undefined || value === null || value === ""
          ? ""
          : String(value);
      if (this.alApplyExpertFilter) this.goQuery();
    },
    setExpertTeamFilter(value) {
      this.queryCriteria.teamType =
        value === undefined || value === null || value === ""
          ? ""
          : value;
      if (this.alApplyExpertFilter) this.goQuery();
    },
    goQuery() {
      const pagination = {
        current: 1,
        pageSize: 20,
      };
      this.handleTableChange(pagination);
    },
    goNewPage(flag) {
//    console.log(flag);
      this.fullscreen = flag;
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      let queryParam = {};
      queryParam.page = pagination.current;
      queryParam.size = pagination.pageSize;
      queryParam.realname = this.queryCriteria.schoolName;
      queryParam.name = this.queryCriteria.name;
      queryParam.zpname = this.queryCriteria.zpname;
      queryParam.principals = this.queryCriteria.principals;
      queryParam.Integrity = this.queryCriteria.Integrity;
      queryParam.provincecode= this.queryCriteria.provincecode;
      queryParam.levelType = this.queryCriteria.levelType || "";
      // queryParam.teamType = this.queryCriteria.teamType || "";
      this.$emit('getApplyZjApplyList', queryParam);
    },
    submitPreview() {
    	console.log("11111");
    		this.show=false;
        this.showPreviewPop = false; 
        this.$emit('updataInfo');
//    lxExpertApplyReview(data).then((res) => {
//      if (res.code === 200) {
//        this.$message.success(res.message);
//        if(this.type == 'alApply'){
//        	this.show=false;
//        	this.showPreviewPop = false; 
//        }else{
//        	 this.showPreviewPop = false; 
//        }
//        this.$emit('updataInfo');
//      } else {
//        this.$message.error(res.message);
//      }
//    });
    },
  },
};
</script>

<style scoped lang="scss">
.list-filter-panel {
  margin-bottom: 14px;
  padding: 14px 16px;
  background: #f8faff;
  border: 1px solid #d6e4ff;
  border-radius: 10px;
}
.list-filter-row {
  margin-bottom: 0;
}
.filter-dimension-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
.filter-dimension-block {
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e6eefc;
  border-radius: 8px;
}
.filter-dimension-block--primary {
  border-color: #b8d4ff;
  background: linear-gradient(180deg, #fff 0%, #f3f8ff 100%);
  box-shadow: 0 1px 4px rgba(0, 90, 245, 0.08);
}
.filter-dimension-title {
  margin-bottom: 10px;
  padding-bottom: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 1px solid #eef3fc;
}
.filter-dimension-block--primary .filter-dimension-title {
  color: #9A0B00;
  border-bottom-color: #d6e4ff;
}
.filter-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.filter-chip-list--lg {
  gap: 10px;
}
.filter-chip {
  display: inline-block;
  min-width: 72px;
  padding: 6px 16px;
  font-size: 14px;
  text-align: center;
  color: #555;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
}
.filter-chip--lg {
  min-width: 96px;
  padding: 8px 22px;
  border-radius: 8px;
}
.filter-chip:hover {
  color: #9A0B00;
  border-color: #91b8ff;
}
.filter-chip.active {
  color: #fff;
  background: #9A0B00;
  border-color: #9A0B00;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 90, 245, 0.25);
}
@media (max-width: 768px) {
  .filter-dimension-grid {
    grid-template-columns: 1fr;
  }
}
.header-search-box {
  font-size: 14px;
  padding-left: 7px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #383838;
  margin-top: 10px;
  .input-style {
    width: 140px;
    height: 30px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    padding: 8px 12px;
    margin: 0 20px 0 6px;
  }
  .search-btn {
    width: 100px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #9A0B00;
    border-radius: 10px;
    margin-left: 10px;
    margin-right: 20px;
    .img-box {
      width: 12px;
      height: 14px;
      margin-right: 8px;
    }
  }
}
.header-time-box {
  width: 363px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  background: #b7d1ff;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #9A0B00;
  border-radius: 10px;
}
.color-red {
  color: #9A0B00;
}
.text1 {
  margin: 18px 0 11px 0;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.contentbox{
	width:500px;
	height:400px;
	position: absolute;
	top:0px;
	left:0px;
	right:0px;
	bottom:0px;
	margin:auto;
	z-index:11111;
	background-color: #fff;
	border-radius:20px;
	box-sizing: border-box;
	overflow: hidden;
	cursor:move;
	border:1px solid #9A0B00;
	.boxheader{
		height:60px;
		background-color: #9A0B00;
		line-height: 60px;
		text-align: center;
		font-size:20px;
		color:#fff;
		position:relative;
	}
	.boxtextarea{
		width:90%;
		height:240px;
		margin:20px auto;
		border:1px solid transparent;
		background-color: #F6F6F6;
		padding:10px 20px;
		box-sizing: border-box;
		display: block;
		resize:none;
	}
	.close{
		width:40px;
		height:20px;
		font-size: 18px;
		font-weight:bolder;
		color:#fff;
		line-height: 20px;
		text-align: center;
		position: absolute;
		top:20px;
		right:10px;
		cursor:pointer;
	}
	.boxbutton{
		width: 116px;
		height: 40px;
		background: #9A0B00;
		border-radius: 9px;
		text-align: center;
		line-height: 40px;
		font-size:16px;
		margin:0px auto;
		display: block;
		color:#FFF;
		cursor: pointer;
	}
}
/*
.expert-table-box
 {
}*/
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
/deep/ .ant-table-row{
  position: relative;
  .ywcimg{
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-hint {
  width: 18px;
  height: 18px;
  margin-right: 9px;
  display: inline-block;
  margin: 0 auto;
}
</style> 